import styled from 'styled-components';

import { Title as UnstyledTitle } from '@glowforge/gf-styled/components/typography';
import { GridContainerWithBackground } from '@glowforge/gf-styled/components/grid-container';
import ImageWidget from '@glowforge/gf-styled/components/contentful-views/image';

const Wrapper = styled(GridContainerWithBackground)`
  &&&& {
    margin-top: 56px;
  }

  @media ${(props) => props.theme.queries.tabletAndUp} {
    display: none;
  }
`;

const CarouselWrapper = styled('div')`
  grid-column: main-start / main-end;
  padding-top: 24px;
`;

const Title = styled(UnstyledTitle)`
  margin-top: -32px;
  grid-column: main-start / main-end;
  color: ${(props) => props.theme.colors.maple.dark};
`;

const Image = styled(ImageWidget)`
  // height is set to a specific aspect ratio on mobile per design spec.
  height: calc(100vw * 0.8);
  object-fit: cover;
  width: 100%;
`;

const BottomContent = styled('div')`
  grid-column: main-start / main-end;
  display: grid;
  justify-items: center;
  grid-row-gap: 12px;
  padding: 24px 0;
`;

export { BottomContent, CarouselWrapper, Title, Image, Wrapper };
